import { CrudForm } from '../shared/CrudPage';
import { restaurantTableService } from '@kss/api';
import type { RestaurantTable, RestaurantTableCreate, RestaurantTableFilter } from '@kss/api';

type F = {
  code: string;
  name: string;
  description: string;
  status: string;
  remarks: string;
  branchId: string;
  floor: string;
  section: string;
  capacity: number;
  tableStatus: string;
  qrToken: string;
  isActive: boolean;
};

const empty: F = {
  code: '',
  name: '',
  description: '',
  status: '',
  remarks: '',
  branchId: '',
  floor: '',
  section: '',
  capacity: 4,
  tableStatus: 'Available',
  qrToken: '',
  isActive: true,
};

export default function NewRestaurantTable() {
  return (
    <CrudForm<RestaurantTable, RestaurantTableCreate, RestaurantTableFilter, F>
      title="restaurant table"
      service={restaurantTableService}
      idKey="restaurantTableId"
      basePath="/panel/restaurant-tables"
      emptyForm={empty}
      fields={[
        { key: 'code', label: 'Table number', required: true, placeholder: 'T-01' },
        { key: 'name', label: 'Name', required: true, placeholder: 'Window 1' },
        { key: 'branchId', label: 'Branch id' },
        { key: 'floor', label: 'Floor', placeholder: 'GF, 1F, Roof' },
        { key: 'section', label: 'Section', placeholder: 'Indoor, Outdoor, Bar' },
        { key: 'capacity', label: 'Capacity', type: 'number' },
        { key: 'tableStatus', label: 'Status', type: 'select', options: [{ value: 'Available', label: 'Available' }, { value: 'Occupied', label: 'Occupied' }, { value: 'Reserved', label: 'Reserved' }, { value: 'OrderPlaced', label: 'Order placed' }, { value: 'Cooking', label: 'Cooking' }, { value: 'Served', label: 'Served' }, { value: 'BillPending', label: 'Bill pending' }] },
        { key: 'qrToken', label: 'QR token (auto-generated)', placeholder: '(server-set)' },
        { key: 'isActive', label: 'Active', type: 'status' },
      ]}
      fromEntity={(r) => ({
        code: ((r as unknown as Record<string, unknown>).code ?? '') as string,
        name: ((r as unknown as Record<string, unknown>).name ?? '') as string,
        description: ((r as unknown as Record<string, unknown>).description ?? '') as string,
        status: ((r as unknown as Record<string, unknown>).status ?? '') as string,
        remarks: ((r as unknown as Record<string, unknown>).remarks ?? '') as string,
        branchId: ((r as unknown as Record<string, unknown>).branchId ?? '') as string,
        floor: ((r as unknown as Record<string, unknown>).floor ?? '') as string,
        section: ((r as unknown as Record<string, unknown>).section ?? '') as string,
        capacity: Number((r as unknown as Record<string, unknown>).capacity ?? 0),
        tableStatus: ((r as unknown as Record<string, unknown>).tableStatus ?? '') as string,
        qrToken: ((r as unknown as Record<string, unknown>).qrToken ?? '') as string,
        isActive: !!r.isActive,
      })}
      toEntity={(f, id) => ({
        restaurantTableId: id,
        code: f.code ? f.code : undefined,
        name: f.name ? f.name : undefined,
        description: f.description ? f.description : undefined,
        status: f.status ? f.status : undefined,
        remarks: f.remarks ? f.remarks : undefined,
        branchId: f.branchId ? f.branchId : undefined,
        floor: f.floor ? f.floor : undefined,
        section: f.section ? f.section : undefined,
        capacity: f.capacity ? Number(f.capacity) : undefined,
        tableStatus: f.tableStatus ? f.tableStatus : undefined,
        qrToken: f.qrToken ? f.qrToken : undefined,
        isActive: f.isActive,
      } as RestaurantTable)}
      validate={(f) => (!f.name.trim() ? 'Name is required' : null)}
    />
  );
}
